/*
  c_staff-posts-tabs
  「このスタッフの投稿」共通パーツ（コーデ / 動画 / ブログ の3タブ + もっと見る）。
  - スタッフコーデ詳細・スタッフランキング詳細の両ページで使用（1元管理）。
  - LEEEP の embed は detail ページで動作しないため、API（/v3/posts・/v3/blogs）を直接叩いて自前描画。
  - 投稿(posts)は has_video で コーデ(画像) / 動画 に重複なく分離。各タブ独立で10件ずつ + もっと見る。
  - staff_id は data-staff-id → URLの staff_id → LEEEP描画後の .LeeepUserLink の順で解決。
  - LEEEP API のスタッフ絞り込みパラメータはエンドポイントで異なる（/v3/posts=staff_id, /v3/blogs=user_id）。
  - data-exclude-current-post="true" のとき、URLの post_id を除外（自分自身の投稿を出さない）。
*/
(() => {
  'use strict';

  const PAGE = 10;
  const roots = document.querySelectorAll('[data-staff-posts-tabs]');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    waitForLeeep(root, 0);
  });

  function waitForLeeep(root, count) {
    if (typeof LeeepCite !== 'undefined' && LeeepCite.site_id) { resolveAndInit(root, 0); return; }
    if (count > 50) return;
    setTimeout(() => waitForLeeep(root, count + 1), 100);
  }

  function resolveAndInit(root, count) {
    const staffId = getStaffId(root);
    if (staffId) { init(root, String(staffId)); return; }
    // コーデ詳細は LEEEP がコーデ詳細を描画して .LeeepUserLink が現れるまで staff_id が取れない。
    // 遅延描画に備えて長めに待つ（最大 ~30秒）。取れなければ何も描画しない。
    if (count > 300) return;
    setTimeout(() => resolveAndInit(root, count + 1), 100);
  }

  function getStaffId(root) {
    if (root.dataset.staffId) return root.dataset.staffId;
    const urlId = new URLSearchParams(location.search).get('staff_id');
    if (urlId) return urlId;
    const link = document.querySelector('.LeeepUserLink');
    const m = link ? (link.getAttribute('href') || '').match(/staff_id=([^&]+)/) : null;
    return m ? decodeURIComponent(m[1]) : '';
  }

  async function init(root, staffId) {
    const websiteId = String(LeeepCite.site_id);
    const excludePostId = root.dataset.excludeCurrentPost === 'true'
      ? (new URLSearchParams(location.search).get('post_id') || '')
      : '';

    // 各パネルに「グリッド + 空メッセージ + もっと見る」の器を用意
    const setupPanel = (name, emptyText, onMore) => {
      const panel = root.querySelector('[data-panel="' + name + '"]');
      if (!panel) return null;
      panel.innerHTML = '';
      const grid = document.createElement('div');
      grid.className = 'c_staff-posts-tabs__grid' + (name === 'blog' ? ' c_staff-posts-tabs__grid--blog' : '');
      const empty = document.createElement('p');
      empty.className = 'c_staff-posts-tabs__empty';
      empty.textContent = emptyText;
      empty.hidden = true;
      const moreWrap = document.createElement('div');
      moreWrap.className = 'c_staff-posts-tabs__more-wrap';
      moreWrap.hidden = true;
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'c_staff-posts-tabs__more';
      more.innerHTML = '<span class="c_staff-posts-tabs__more-text">もっと見る</span>'
        + '<span class="c_staff-posts-tabs__more-icon" aria-hidden="true">+</span>';
      more.addEventListener('click', () => onMore(more));
      moreWrap.appendChild(more);
      panel.appendChild(grid);
      panel.appendChild(empty);
      panel.appendChild(moreWrap);
      return { grid, empty, moreWrap, more };
    };

    const setMoreLoading = (btn, loading) => {
      if (!btn) return;
      btn.disabled = loading;
      const t = btn.querySelector('.c_staff-posts-tabs__more-text');
      if (t) t.textContent = loading ? '読み込み中…' : 'もっと見る';
    };

    // ---- 状態（コーデ/動画は共有ストリームをバッファに溜めて各タブ独立に表示） ----
    let streamOffset = 0, streamDone = false, postsLoading = false;
    let blogOffset = 0, blogDone = false, blogLoading = false;
    const buf = { image: [], video: [] };
    const shown = { image: 0, video: 0 };

    const coorde = setupPanel('post', 'コーデがありません', (btn) => loadMorePosts('image', btn));
    const video = setupPanel('video', '動画がありません', (btn) => loadMorePosts('video', btn));
    const blog = setupPanel('blog', 'このスタッフのブログ記事はありません', (btn) => loadMoreBlogs(btn));
    const postPanelOf = { image: coorde, video: video };

    const fetchStreamPage = async () => {
      if (streamDone) return;
      let url = 'https://cite.leeep.jp/v3/posts'
        + '?website_id=' + encodeURIComponent(websiteId)
        + '&staff_id=' + encodeURIComponent(staffId)
        + '&count=' + PAGE + '&offset=' + streamOffset + '&without_total=true';
      if (excludePostId) url += '&exclude_post_id=' + encodeURIComponent(excludePostId);
      let posts = [];
      try {
        const res = await fetch(url);
        if (res.ok) { const j = await res.json(); posts = j.posts || []; }
      } catch (e) { console.warn('[c_staff-posts-tabs] posts page fetch failed', e); }
      streamOffset += posts.length;
      if (posts.length < PAGE) streamDone = true;
      posts.forEach((p) => {
        if (!p) return;
        (p.has_video ? buf.video : buf.image).push(renderPostCard(p));
      });
    };

    const ensureBuffer = async (type, needed) => {
      while (buf[type].length < needed && !streamDone) { await fetchStreamPage(); }
    };

    const renderPostsTab = (type) => {
      const g = postPanelOf[type];
      if (!g) return;
      const limit = Math.min(shown[type], buf[type].length);
      for (let i = g.grid.children.length; i < limit; i++) {
        g.grid.insertAdjacentHTML('beforeend', buf[type][i]);
      }
      const has = g.grid.children.length > 0;
      g.empty.hidden = has || !(streamDone && buf[type].length === 0);
      const moreAvailable = buf[type].length > g.grid.children.length || !streamDone;
      g.moreWrap.hidden = !moreAvailable;
    };

    const loadMorePosts = async (type, btn) => {
      if (postsLoading) return;
      postsLoading = true;
      setMoreLoading(btn, true);
      shown[type] += PAGE;
      await ensureBuffer(type, shown[type]);
      renderPostsTab(type);
      postsLoading = false;
      setMoreLoading(btn, false);
    };

    const fetchBlogsPage = async () => {
      if (blogDone) return;
      const url = 'https://cite.leeep.jp/v3/blogs'
        + '?website_id=' + encodeURIComponent(websiteId)
        + '&user_id=' + encodeURIComponent(staffId)
        + '&count=' + PAGE + '&offset=' + blogOffset + '&without_total=true';
      let blogs = [];
      try {
        const res = await fetch(url);
        if (res.ok) { const j = await res.json(); blogs = j.blogs || []; }
      } catch (e) { console.warn('[c_staff-posts-tabs] blogs page fetch failed', e); }
      blogOffset += blogs.length;
      if (blogs.length < PAGE) blogDone = true;
      if (blog) blogs.forEach((b) => blog.grid.insertAdjacentHTML('beforeend', renderBlogCard(b)));
    };

    const updateBlogsUI = () => {
      if (!blog) return;
      const has = blog.grid.children.length > 0;
      blog.empty.hidden = has || !blogDone;
      blog.moreWrap.hidden = blogDone;
    };

    const loadMoreBlogs = async (btn) => {
      if (blogLoading) return;
      blogLoading = true;
      setMoreLoading(btn, true);
      await fetchBlogsPage();
      blogLoading = false;
      setMoreLoading(btn, false);
      updateBlogsUI();
    };

    setupTabs(root);

    // 初回ロード（各タブ PAGE 件を目標に取得）
    shown.image = PAGE;
    shown.video = PAGE;
    await ensureBuffer('image', PAGE);
    await ensureBuffer('video', PAGE);
    renderPostsTab('image');
    renderPostsTab('video');
    await fetchBlogsPage();
    updateBlogsUI();

    root.hidden = false;
  }

  function setupTabs(root) {
    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach((t) => {
          const active = t.dataset.tab === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          const active = p.dataset.panel === target;
          p.classList.toggle('is-active', active);
          p.hidden = !active;
        });
      });
    });
  }

  const esc = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const formatDate = (iso) => {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear() + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2);
  };

  function renderPostCard(post) {
    const link = esc(post.post_detail_page_link || ('/pages/staff-coordinate-detail?post_id=' + post.id));
    const content = (post.contents && post.contents[0]) || {};
    const thumb = esc(content.thumbnail_url || content.media_url || '');
    const isVideo = content.type === 'video' || post.has_video;
    const caption = esc(post.caption);
    return '<a class="c_staff-posts-tabs__card" href="' + link + '">'
      + '<div class="c_staff-posts-tabs__card-image-wrap">'
      + '<img class="c_staff-posts-tabs__card-image" src="' + thumb + '" alt="' + caption + '" loading="lazy">'
      + (isVideo ? '<div class="c_staff-posts-tabs__card-play"><svg viewBox="0 0 96 96" fill="#fff"><path d="M85.2 42.6c4.4 2.2 4.4 8.5 0 10.8L8.7 91.3C4.7 93.3 0 90.4 0 87V10C0 5.6 4.7 2.7 8.7 4.7l76.5 38z"/></svg></div>' : '')
      + '</div>'
      + '</a>';
  }

  function renderBlogCard(blog) {
    const link = esc(blog.blog_url || ('/pages/staff-blog-detail?blog_id=' + (blog.slug || blog.id)));
    const thumb = esc(blog.featured_thumbnail_url || blog.featured_image_url || '');
    const title = esc(blog.title);
    const date = blog.posted_at ? esc(formatDate(blog.posted_at)) : '';
    return '<a class="c_staff-posts-tabs__card c_staff-posts-tabs__card--blog" href="' + link + '">'
      + '<div class="c_staff-posts-tabs__card-image-wrap">'
      + '<img class="c_staff-posts-tabs__card-image" src="' + thumb + '" alt="' + title + '" loading="lazy">'
      + '</div>'
      + (date ? '<time class="c_staff-posts-tabs__card-date">' + date + '</time>' : '')
      + '<div class="c_staff-posts-tabs__card-title">' + title + '</div>'
      + '</a>';
  }
})();
